export default __webpack_public_path__ + "static/media/phonebook.e4355707.jpg";